import React from 'react'
import './Why_clients.css'
import Heading_title from '../../common-components/common-title/heading-title/Heading_title'

const Why_clients = () => {

    const clientdata = [
        {
            number: '10 Lack',
            name: 'Satisfied Customers',
            image: '/assets/images/home/why-clients/customers.png'
        },
        {
            number: '11,000',
            name: 'Retail Store',
            image: '/assets/images/home/why-clients/expert.png'
        },
        {
            number: '100',
            name: 'Distributors network',
            image: '/assets/images/home/why-clients/support.png'
        },
        {
            number: '150',
            name: 'Towns',
            image: '/assets/images/home/why-clients/city.png'
        },

    ];

    return (
        <>
            <section className='Why_clients_sec'>
                <div className='container'>
                    {/* <Heading_title subtitle={'Why Client Choose Nutricos '} /> */}

                    <div className='clientssec'>
                        <div className='row'>
                            {clientdata.map((data, index) => (
                                <div className='col-lg-3 col-sm-6 mb-5'>
                                    <div className='custbox'>
                                        <div className='icondiv'>
                                            <img className='img' src={data.image} alt="icon" />
                                        </div>
                                        <div className='contdiv'>
                                            <h6 className='number'>{data.number}+</h6>
                                            <p className='name'>{data.name}</p>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>

                </div>
            </section>
        </>
    )
}

export default Why_clients